import { TkDownloadLinkProps } from "../../../type/componentsType/TkDownloadLink";
import { decodeBase64 } from "../../../utils/TkFileDecode";
import React, { MouseEvent } from "react";
import "./_style.scss";
import TkButton from "../TkButton";

const extractMimeType = (base64String: string): string | null => {
  // Base64文字列からMIMEタイプを抽出する関数
  const match = base64String.match(/^data:(.*?);base64,/);
  return match ? match[1] : null;
};

const getFileExtensionFromMimeType = (mimeType: string): string => {
  // MIMEタイプから拡張子を取得する関数
  if (!mimeType) return "";
  const extension = mimeType.split("/")[1];
  return extension ? "." + extension : "";
};

export const TkDownloadLink: React.FC<TkDownloadLinkProps> = (props) => {
  const {
    dataname,
    base64filedata,
    onClick,
    isButton = false,
    buttonDisabled = false,
    buttonName,
    linkName,
    linkDisabled,
    downloadBase64 = false,
    ...rest
  } = props;

  const handleClick = (event: MouseEvent<HTMLAnchorElement> | any) => {
    if (buttonDisabled || linkDisabled) {
      // ボタンまたはリンクが無効化されている場合、イベントをキャンセル
      event.preventDefault();
      return;
    }

    // Base64デコードの結果を取得し、onClickコールバックを呼び出す
    let resultdecodeInfo = decodeBase64(dataname, base64filedata);
    const newObj = {
      target: {
        value: event.currentTarget.href,
        msg: resultdecodeInfo.messeageid,
        info: resultdecodeInfo,
      },
    };

    onClick && onClick(newObj);

    if (downloadBase64 && base64filedata) {
      event.preventDefault(); // デフォルトの動作を阻止

      const mimeType = extractMimeType(base64filedata);
      const base64Data = base64filedata.replace(/^data:.*;base64,/, "");

      if (mimeType) {
        let extension = getFileExtensionFromMimeType(mimeType);
        let fileName = dataname.includes(".") ? dataname : dataname + extension;

        const isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );

        // Safariの場合、ファイルタイプがPDFなら拡張子を大文字の.PDFに変更
        if (isSafari && mimeType === "application/pdf") {
          extension = ".PDF";
          fileName = dataname.includes(".") ? dataname : dataname + extension;
        }

        // Base64データをバイト配列に変換
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(null)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        // Blob URLを作成
        const blobUrl = URL.createObjectURL(blob);

        // 動的リンク要素を作成
        const link = document.createElement("a");
        link.href = blobUrl;
        link.target = "_blank";
        link.rel = "nofollow noopener noreferrer";
        link.download = fileName;

        // Safariはリンクを手動でクリックする必要がある
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // URLオブジェクトを解放
        URL.revokeObjectURL(blobUrl);
        return;
      }
    }
  };

  return (
    <a
      className={`LinkName ${linkDisabled ? "disabled" : ""}`}
      {...rest}
      onClick={handleClick}
      target="_blank"
      rel="noreferrer"
    >
      {isButton ? (
        <TkButton disabled={buttonDisabled}>{buttonName ?? dataname}</TkButton>
      ) : (
        linkName ?? dataname
      )}
    </a>
  );
};

export default TkDownloadLink;
